import React from "react";
import "./Loading.css";

const Loading = () => (
  <div className="loading-container">
    <svg width="88" height="88" viewBox="0 0 88 88">
      <style>
        {`
          @keyframes circular-dash {
            0% {
              stroke-dasharray: 1px, 200px;
              stroke-dashoffset: 0px;
            }
            50% {
              stroke-dasharray: 100px, 200px;
              stroke-dashoffset: -15px;
            }
            100% {
              stroke-dasharray: 100px, 200px;
              stroke-dashoffset: -125px;
            }
          }
        `}
      </style>
      <circle
        cx="44"
        cy="44"
        r="20.2"
        fill="none"
        strokeWidth="3.6"
        stroke="rgb(63, 81, 181)"
        style={{
          animation: "circular-dash 1s ease-in-out infinite",
          strokeDasharray: "80px, 200px",
          strokeDashoffset: "0px",
        }}
      ></circle>
    </svg>
  </div>
);

export default Loading;
